import { EMPTY_FIELD } from 'constants/emptyField';

import { CardTable } from 'shared/mui/Card/CardTableNew/CardTable';
import { TableRowWrapper } from 'shared/mui/Table/TableRowWrapperNew/TableRowWrapper';
import { DateTimeField, FunctionField, TextField } from 'shared/react-admin/Fields';
import { Preset } from 'types/embedded/preset';

export const PresetsShowGeneralTab: React.FC = () => (
  <CardTable tableBodyProps={{ sx: { '& td': { width: '324px' } } }}>
    <TableRowWrapper label="ID">
      <TextField source="originId" />
    </TableRowWrapper>
    <TableRowWrapper label="Мерчант">
      <FunctionField render={(r: Preset) => r.merchant?.name || EMPTY_FIELD} />
    </TableRowWrapper>
    <TableRowWrapper label="Шлюз">
      <FunctionField render={(r: Preset) => r.gateway?.name || EMPTY_FIELD} />
    </TableRowWrapper>
    <TableRowWrapper label="Валюта">
      <FunctionField
        render={({ currency }: Preset) =>
          currency ? `${currency?.alphaCode} / ${currency?.name}` : EMPTY_FIELD
        }
      />
    </TableRowWrapper>
    <TableRowWrapper label="Общий комментарий пресетов пополнения">
      <FunctionField render={(record: Preset) => record?.paymentComment || EMPTY_FIELD} />
    </TableRowWrapper>
    <TableRowWrapper label="Дата создания">
      <DateTimeField inline source="createdAt" />
    </TableRowWrapper>
    <TableRowWrapper label="Дата редактирования">
      <DateTimeField inline source="updatedAt" />
    </TableRowWrapper>
  </CardTable>
);
